import {
    GET_ALL_PLAN_GROUPS_BEGIN, GET_ALL_PLAN_GROUPS_SUCCESS, GET_ALL_PLAN_GROUPS_FAILURE,
    GET_PLAN_GROUP_BEGIN, GET_PLAN_GROUP_SUCCESS, GET_PLAN_GROUP_FAILURE,
    POST_PLAN_GROUP_BEGIN, POST_PLAN_GROUP_SUCCESS, POST_PLAN_GROUP_FAILURE,
    PUT_PLAN_GROUP_BEGIN, PUT_PLAN_GROUP_SUCCESS, PUT_PLAN_GROUP_FAILURE,
    DELETE_PLAN_GROUP_BEGIN, DELETE_PLAN_GROUP_SUCCESS, DELETE_PLAN_GROUP_FAILURE
} from '../constants/ActionTypes'

const initialState = {

    // Get All Plan Groups
    allPlanGroups: null,
    isLoadingAllPlanGroups: false,
    hasErrorAllPlanGroups: null,

    // Get Plan Group
    selectedPlanGroup: null,
    isLoadingSelectedPlanGroup: false,
    hasErrorSelectedPlanGroup: null,

    // Post Plan Group
    createdPlanGroup: null,
    isCreatingPlanGroup: false,
    hasErrorCreatedPlanGroup: null,

    // Put Plan Group
    updatedPlanGroup: null,
    isUpdatingPlanGroup: false,
    hasErrorUpdatedPlanGroup: null,

    // Delete Plan Group
    deletedPlanGroup: null,
    isDeletingPlanGroup: false,
    hasErrorDeletedPlanGroup: null
}

/**
 * @description Reducer function for managing the state of the Plan Group.
 *
 * @author Maria Eduarda Franke
 * @param {Object} state - The current state of the Plan Group.
 * @param {Object} action - The action object that contains the type and payload.
 * @returns {Object} - The updated state of the Plan Group.
 */
const ReducerPlanGroup = (state = initialState, action) => {
    switch (action.type) {

    // Get All Plan Groups
    case GET_ALL_PLAN_GROUPS_BEGIN: {
        return {
            ...state,
            isLoadingAllPlanGroups: true
        }
    }
    case GET_ALL_PLAN_GROUPS_SUCCESS: {
        return {
            ...state,
            allPlanGroups: action.payload,
            isLoadingAllPlanGroups: false,
            hasErrorAllPlanGroups: null
        }
    }
    case GET_ALL_PLAN_GROUPS_FAILURE: {
        return {
            ...state,
            allPlanGroups: null,
            isLoadingAllPlanGroups: false,
            hasErrorAllPlanGroups: action.payload
        }
    }

    // Get Plan Group
    case GET_PLAN_GROUP_BEGIN: {
        return {
            ...state,
            isLoadingSelectedPlanGroup: true
        }
    }
    case GET_PLAN_GROUP_SUCCESS: {
        return {
            ...state,
            selectedPlanGroup: action.payload,
            isLoadingSelectedPlanGroup: false,
            hasErrorSelectedPlanGroup: null
        }
    }
    case GET_PLAN_GROUP_FAILURE: {
        return {
            ...state,
            selectedPlanGroup: null,
            isLoadingSelectedPlanGroup: false,
            hasErrorSelectedPlanGroup: action.payload
        }
    }

    // Post Plan Group
    case POST_PLAN_GROUP_BEGIN: {
        return {
            ...state,
            isCreatingPlanGroup: true
        }
    }
    case POST_PLAN_GROUP_SUCCESS: {
        return {
            ...state,
            createdPlanGroup: action.payload,
            isCreatingPlanGroup: false,
            hasErrorCreatedPlanGroup: null
        }
    }
    case POST_PLAN_GROUP_FAILURE: {
        return {
            ...state,
            createdPlanGroup: null,
            isCreatingPlanGroup: false,
            hasErrorCreatedPlanGroup: action.payload
        }
    }

    // Put Plan Group
    case PUT_PLAN_GROUP_BEGIN: {
        return {
            ...state,
            isUpdatingPlanGroup: true
        }
    }
    case PUT_PLAN_GROUP_SUCCESS: {
        return {
            ...state,
            updatedPlanGroup: action.payload,
            isUpdatingPlanGroup: false,
            hasErrorUpdatedPlanGroup: null
        }
    }
    case PUT_PLAN_GROUP_FAILURE: {
        return {
            ...state,
            updatedPlanGroup: null,
            isUpdatingPlanGroup: false,
            hasErrorUpdatedPlanGroup: action.payload
        }
    }

    // Delete Plan Group
    case DELETE_PLAN_GROUP_BEGIN: {
        return {
            ...state,
            isDeletingPlanGroup: true
        }
    }
    case DELETE_PLAN_GROUP_SUCCESS: {
        return {
            ...state,
            deletedPlanGroup: action.payload,
            isDeletingPlanGroup: false,
            hasErrorDeletedPlanGroup: null
        }
    }
    case DELETE_PLAN_GROUP_FAILURE: {
        return {
            ...state,
            deletedPlanGroup: null,
            isDeletingPlanGroup: false,
            hasErrorDeletedPlanGroup: action.payload
        }
    }

    default: return state

    }
}

export default ReducerPlanGroup